/**
 * Packaging rules the report points clients to under lever 3. Every figure here was checked
 * against its source (gov.uk, or EUR-Lex for the EU rule) on the date below. Check them again before each tax year (April) and update
 * CHECKED_ON; the report prints that date next to them.
 */
export const COMPLIANCE_CHECKED_ON = "2026-10-06";

export const PLASTIC_PACKAGING_TAX = {
  /** From 1 April 2026 */
  ratePerTonnePence: 22882,
  rateFrom: "2026-04-01",
  /** Register if you manufacture in, or import into, the UK this much finished plastic packaging in 12 months (filled packaging counts) */
  thresholdTonnes: 10,
  /** Packaging with at least this share of recycled plastic is not taxed */
  recycledContentExempt: 0.3,
  source: "https://www.gov.uk/guidance/check-if-you-need-to-register-for-plastic-packaging-tax",
};

export const PACKAGING_EPR = {
  /** Large producers pay waste disposal fees */
  largeProducer: { turnoverPence: 200_000_000, tonnes: 50 },
  /** Small producers report data but do not pay disposal fees */
  smallProducer: { turnoverPence: 100_000_000, tonnes: 25 },
  /** Year 2 fees: red = 1.2 × amber; packaging without enough recyclability information is treated as red */
  redToAmber: 1.2,
  source: "https://www.gov.uk/guidance/extended-producer-responsibility-for-packaging-who-is-affected-and-what-to-do",
};

/**
 * EU Packaging and Packaging Waste Regulation (EU) 2025/40, Article 24: from 1 January 2030, whoever fills
 * grouped, transport or e-commerce packaging keeps empty space to 50% or less. Empty space is the packaging's
 * volume less the product's, so filler counts as empty. The EU sets the exact method by 12 February 2028, so
 * until then our figure is an estimate from parcel and product sizes (the one-product parcels on page 2).
 */
export const EU_EMPTY_SPACE = {
  maxShare: 0.5,
  from: "2030-01-01",
  source: "https://eur-lex.europa.eu/eli/reg/2025/40/oj",
};

/** Whether measured empty space is over the EU limit, near it (within 10 points) or within it. */
export function emptySpaceStanding(airShare: number): "over" | "near" | "within" {
  if (airShare > EU_EMPTY_SPACE.maxShare) return "over";
  return airShare > EU_EMPTY_SPACE.maxShare - 0.1 ? "near" : "within";
}
